import CONSTANTS from "@/common/constants";

// set Cookie
const setLocalStorage = (cookie_name, value) => {
  localStorage.setItem(cookie_name, value);
};

// get Cookie
function getLocalStorage(name) {
  return localStorage.getItem(name);
}

// remove Cookie
function removeCookie(name) {
  localStorage.removeItem(name);
}

function getToken(name) {
  const token = getLocalStorage(name);
  if (token) {
    return JSON.parse(decodeURIComponent(token));
  }
  return null;
}

function parsePrice(price) {
  if (price === null || price === undefined) return 0;
  if (typeof price === "number") return price;

  const strPrice = String(price).trim();
  if (!strPrice) return 0;

  return parseInt(strPrice.replace(/,/g, "")) || 0;
}

function setToken(name, token) {
  const tokenString = encodeURIComponent(JSON.stringify(token));
  setLocalStorage(name, tokenString, 1296e6);
}

function removeToken(name) {
  setLocalStorage(name, "");
}

// returns YYYY-MM-DD
function dateFormat(dateString) {
  dateString = dateString.replace("KST", "");
  let date = new Date(dateString);
  if (date.getTime() < 0) {
    return "-";
  }
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return `${year}-${month}-${day}`;
}

function datetimeFormat(date) {
  let month = date.getMonth() + 1;
  let day = date.getDate();
  const time = date.toLocaleTimeString("ko-KR", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  day = day.toString().padStart(2, "0");
  month = month.toString().padStart(2, "0");
  return date.getFullYear() + "-" + month + "-" + day + " " + time;
}

function getDateFormat(date) {
  date = new Date(date);

  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  let ma = hour >= 12 ? "오후" : "오전";
  hour = hour > 12 ? hour - 12 : hour;

  year = year.toString().padStart(2, "0");
  month = month.toString().padStart(2, "0");
  day = day.toString().padStart(2, "0");

  hour = hour.toString().padStart(2, "0");
  min = min.toString().padStart(2, "0");
  sec = sec.toString().padStart(2, "0");

  return `${year}-${month}-${day} ${ma} ${hour}:${min}:${sec}`;
}
function formatBirthDate(dateString) {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  return `${year}-${month}-${day}`;
}
function getDateFormatToYYYYMMDDHHMMSS() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

// return role string
function changeRoleToStr(code) {
  let str = "";
  switch (code) {
    case "R01":
      str = "Root";
      break;
    case "R02":
      str = "Manager";
      break;
    case "R03":
      str = "Supervisor";
      break;
    case "R04":
      str = "Operator";
      break;
    case "R05":
      str = "Crowdworker";
      break;
  }
  return str;
}

// return role code
function changeRoleToCode(str) {
  let code = "";
  switch (str.toUpperCase()) {
    case "ROOT":
      code = "R01";
      break;
    case "MANAGER":
      code = "R02";
      break;
    case "SUPERVISOR":
      code = "R03";
      break;
    case "OPERATOR":
      code = "R04";
      break;
    case "CROWDWORKER":
      str = "R05";
      break;
  }
  return code;
}

// return status code
function changeStatusToCode(str) {
  let code = "";
  switch (str.toUpperCase()) {
    case "ACTIVATE":
      code = "S01";
      break;
    case "DEACTIVATE":
      code = "S02";
      break;
    case "WAITING":
      code = "S03";
      break;
    case "INITIALIZATION":
      code = "S04";
      break;
    case "DELETED":
      code = "S05";
      break;
  }
  return code;
}

// check login response code
function checkLoginCode(code) {
  let msg = "";
  switch (code) {
    case "L0001":
      msg = "계정이 존재하지 않습니다.";
      break;
    case "L0002":
      msg = "비밀번호가 틀립니다.";
      break;
    case "L0003":
      msg = "계정이 비활성화 상태입니다.";
      break;
    case "L0004":
      msg = "신규 생성된 계정입니다.";
      break;
    case "L0005":
      msg = "계정이 삭제된 상태입니다.";
      break;
    case "L0006":
      msg = "비밀번호가 초기화된 상태입니다.";
      break;
  }
  return msg;
}

function getRandomKey(ref = [], prefix = "") {
  const key = Math.random().toString(36).replace("0.", "");
  if (ref.includes(`${key}${prefix}`)) {
    return this.getRandomKey(ref);
  }
  return `${key}`;
}

function toDataURL(url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    const fr = new FileReader();
    fr.onloadend = () => {
      callback(fr.result);
    };
    fr.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.onerror = () => {
    window.location.href = `/guide/certification?errorParam=${url}`;
  };
  xhr.responseType = "blob";
  xhr.send();
}

function comma(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

function setWorkCode(code) {
  let str = "";
  switch (code) {
    case 0:
      str = "작업 전";
      break;
    case 1:
      str = "작업 중";
      break;
    case 2:
      str = "작업 완료";
      break;
    case 3:
      str = "삭제";
      break;
    case 4:
      str = "검수 중";
      break;
    case 5:
      str = "검수 반려";
      break;
    case 6:
      str = "검수 완료";
      break;
    case 7:
      str = "검수 완료(일괄)";
      break;
    case 8:
      str = "삭제 완료";
      break;
    case 9:
      str = "삭제 완료(일괄)";
      break;
  }
  return str;
}

function checkObjectHasError(objData) {
  const attributeErrors = checkAttributesHasError(objData.attributes);
  const hasAttributeError = attributeErrors.some((v) => v);

  const OPTION_ERROR_MAP = {
    BOX: checkBoxSizeHasError,
    POLYGON: checkPolygonHasError,
  };

  const method = OPTION_ERROR_MAP[objData.type];
  let hasOptionError = false;
  if (method) {
    hasOptionError = !!method(objData).length;
  }

  let hasSideError = false;
  if (
    objData.type === "POLYGON" &&
    (objData.lineAttributes?.length > 0 || objData.lineOptions?.allRequired)
  ) {
    const fieldNotValid = objData.lineAttributes
      .map((line) => checkAttributesHasError(line.attributes).some((x) => x))
      .some((x) => x);

    // allSideRequired 일 떄, 검증
    let isSomeSideNotExists = false;
    if (objData.lineOptions.allRequired) {
      let allSegments = [];
      objData.lineAttributes.forEach((line) => {
        const segments = getSideSegments(
          objData.points.length,
          line.startPointNum,
          line.endPointNum
        );
        allSegments.push(...segments);
      });
      allSegments = distinctNestedArray(allSegments);
      isSomeSideNotExists = objData.points.length !== allSegments.length;
    }

    hasSideError = fieldNotValid || isSomeSideNotExists;
  }

  return {
    attribute: hasAttributeError,
    option: hasOptionError,
    side: hasSideError,
  };
}

function checkAttributesHasError(attributes) {
  let ret = [];
  attributes.forEach((attr, idx) => {
    if (!isAttributeVisible(attributes, idx)) {
      ret.push(false);
      return;
    }

    switch (attr.type) {
      case "INPUT":
        ret.push(checkInputHasError(attr));
        break;
      case "CHECKBOX":
        ret.push(checkCheckboxHasError(attr));
        break;
      case "RADIO":
        ret.push(checkRadioHasError(attr));
        break;
    }
  });
  return ret;
}
function checkInputHasError(attr) {
  const value = attr.values[0].value || "";

  if (!attr.option.required) {
    return false;
  }

  if (attr.option.required && value === "") {
    return true;
  }

  if (attr.option.type === "STRING") {
    /** 스트링에서 개행, 띄어쓰기를 필터링하고 스트링의 길이를 측정한다 */
    //const filtered = value.replace(/[\r\n\s]/g, "").length;
    if (
      value.length < attr.option.minimum ||
      attr.option.maximum < value.length
    ) {
      return true;
    }
  }

  if (attr.option.type === "NUMBER") {
    if (value < attr.option.minimum || attr.option.maximum < value) {
      return true;
    }
  }

  if (attr.option.type === "WORD") {
    if (checkWordHasError(attr)) {
      return true;
    }
  }

  return false;
}
function checkCheckboxHasError(attr) {
  if (!attr.option.required) {
    return false;
  }
  return attr.values.every((x) => !x.selected);
}
function checkRadioHasError(attr) {
  if (!attr.option.required) {
    return false;
  }

  return attr.values.every((x) => !x.selected);
}
function checkWordHasError(attr) {
  // const BANNED_WORDS = CONSTANTS.ATTRIBUTE.BANNED_WORDS;
  const value = attr.values[0].value;
  // let hasError = false;
  // BANNED_WORDS.forEach((BAN_WORD) => {
  //   if (value.includes(BAN_WORD)) {
  //     hasError = true;
  //     return;
  //   }
  // });
  // if (hasError) {
  //   return true;
  // }

  const wordCount = value
    .trim()
    .split("\n")
    .filter((x) => x !== "").length;
  if (wordCount < attr.option.minimum || attr.option.maximum < wordCount) {
    return true;
  }

  return false;
}
function checkWordHasWarn(attr) {
  const WARN_WORDS = CONSTANTS.ATTRIBUTE.WARN_WORDS;
  const value = attr.values[0].value;

  const hasWarn = WARN_WORDS.some((word) => value.includes(word));

  return hasWarn;
}

function checkBoxSizeHasError({ points, options }) {
  const errors = [];

  const WIDTH =
    points.length > 2
      ? points[4][0] - points[0][0]
      : points[1][0] - points[0][0];
  const HEIGHT =
    points.length > 2
      ? points[4][1] - points[0][1]
      : points[1][1] - points[0][1];

  const DIAGONAL = Math.sqrt(WIDTH ** 2 + HEIGHT ** 2);
  const conditions = { WIDTH, HEIGHT, DIAGONAL };

  options.forEach((opt) => {
    if (!Object.keys(conditions).includes(opt.type)) {
      return [];
    }

    if (opt.condition === "MIN") {
      if (opt.value >= conditions[opt.type]) {
        errors.push(opt);
      }
    }

    if (opt.condition === "MAX") {
      if (opt.value <= conditions[opt.type]) {
        errors.push(opt);
      }
    }
  });

  return errors;
}

function checkPolygonHasError({ points, options }) {
  const getMinMaxCoords = (points) => {
    const minX = Math.min(...points.map((pt) => pt[0]));
    const minY = Math.min(...points.map((pt) => pt[1]));
    const maxX = Math.max(...points.map((pt) => pt[0]));
    const maxY = Math.max(...points.map((pt) => pt[1]));

    return { min: [minX, minY], max: [maxX, maxY] };
  };

  const errors = [];

  const { min, max } = getMinMaxCoords(points);

  const WIDTH = max[0] - min[0];
  const HEIGHT = max[1] - min[1];
  const conditions = { WIDTH, HEIGHT };

  options.forEach((opt) => {
    if (opt.condition === "MIN") {
      if (opt.value >= conditions[opt.type]) {
        errors.push(opt);
      }
    }

    if (opt.condition === "MAX") {
      if (opt.value <= conditions[opt.type]) {
        errors.push(opt);
      }
    }

    if (opt.condition === "EQUALS") {
      if (opt.value !== points.length) {
        errors.push(opt);
      }
    }
  });

  return errors;
}

function validateGroupPoint(object) {
  let isGroupValid = true;

  object.childrens.forEach((child) => {
    const attributes = child.attributes;
    const errors = checkAttributesHasError(attributes);

    // group child의 각 attribute 검증
    attributes.forEach((attr, idx) => {
      attr.isValid = !errors[idx];
    });

    const error = errors.some((err) => err);
    // group child 의 valid 검증
    child.currentStatus.error = error;
    child.valid = !error;
    if (error) {
      isGroupValid = false;
    }
  });

  // group 의 valid 검증
  object.valid = isGroupValid;
  object.currentStatus.error = !isGroupValid;
  return object;
}

function executeCompleteCheck(workType, status) {
  const check = { deactivate: false, hidden: false };

  if (
    workType === "OPERATOR" &&
    ![
      "WORK_BEFORE",
      "WORK_IN_PROGRESS",
      "WORK_COMPLETE",
      "INSPECT_REJECT",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  if (
    workType === "INSPECTOR" &&
    ![
      "WORK_BEFORE",
      "WORK_IN_PROGRESS",
      "WORK_COMPLETE",
      "DELETE_REQUEST",
      "INSPECT_IN_PROGRESS",
      "INSPECTING_BY_MANAGER",
      "INSPECT_COMPLETE",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  if (
    workType === "MANAGER" &&
    [
      "INSPECT_COMPLETE",
      "INSPECT_ALL_COMPLETE",
      "DELETE_COMPLETE",
      "DELETE_ALL_COMPLETE",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  return check;
}
function executeDeleteCheck(workType, status) {
  const check = { deactivate: false, hidden: false };

  if (
    workType === "OPERATOR" &&
    ![
      "WORK_BEFORE",
      "WORK_IN_PROGRESS",
      "WORK_COMPLETE",
      "INSPECT_REJECT",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  if (
    workType === "INSPECTOR" &&
    ![
      "WORK_BEFORE",
      "WORK_IN_PROGRESS",
      "WORK_COMPLETE",
      "DELETE_REQUEST",
      "DELETE_COMPLETE",
      "INSPECT_IN_PROGRESS",
      "INSPECT_REJECT",
      "INSPECT_COMPLETE",
      "DELETE_COMPLETE",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  if (workType === "MANAGER" && status === "DELETE_REQUEST") {
    check.deactivate = true;
  }
  if (workType === "MANAGER" && status === "DELETE_COMPLETE") {
    check.deactivate = true;
  }
  if (workType === "MANAGER" && status === "DELETE_ALL_COMPLETE") {
    check.deactivate = true;
  }

  return check;
}
function executeRejectCheck(workType, status) {
  const check = { deactivate: false, hidden: false };

  if (workType === "OPERATOR") {
    check.hidden = true;
  }

  if (
    workType === "INSPECTOR" &&
    ![
      "WORK_COMPLETE",
      "DELETE_REQUEST",
      "INSPECT_COMPLETE",
      "INSPECT_IN_PROGRESS",
      "DELETE_COMPLETE",
    ].includes(status)
  ) {
    check.deactivate = true;
  }

  if (workType === "MANAGER" && status === "WORK_BEFORE") {
    check.deactivate = true;
  }
  if (workType === "MANAGER" && status === "WORK_IN_PROGRESS") {
    check.deactivate = true;
  }
  if (workType === "MANAGER" && status === "INSPECT_REJECT") {
    check.deactivate = true;
  }

  return check;
}

function getComplementaryColor(color) {
  color = color.toUpperCase();
  let result = "";
  const hex = "0123456789ABCDEF";
  color.split("").forEach((char) => {
    const idx = hex.indexOf(char);
    result += idx > -1 ? hex[hex.length - idx - 1] : "";
  });
  return `#${result}`;
}

function copyClipboard(value) {
  const el = document.createElement("textarea");
  el.value = value;
  document.body.appendChild(el);

  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}

/** 사이즈 변환 byte -> kb, mb, gb, tb */
function convertSize(byte) {
  if (!byte || byte <= 0) return 0;

  const byteUnits = ["KB", "MB", "GB", "TB"];

  for (let i = 0; i < byteUnits.length; i++) {
    byte = Math.floor(byte / 1024);
    if (byte < 1024) return byte.toFixed(2) + " " + byteUnits[i];
  }
}

function sortClassTypes(classes) {
  const CLASS_TYPES = [
    "BOX",
    "POLYGON",
    "GROUP_POINT",
    "SINGLE_POINT",
    "ATTRIBUTE",
  ];

  const sortedClasses = classes.sort(
    (a, b) => CLASS_TYPES.indexOf(a) - CLASS_TYPES.indexOf(b)
  );

  return sortedClasses;
}

function getExactType(x) {
  if (x == null) {
    return "null";
  }

  const t = typeof x;
  if (t != "object") {
    return t;
  }

  let c = Object.prototype.toString.apply(x);
  c = c.substring(8, c.length - 1); // [object ?]의 특성을 이용함

  if (c != "Object") {
    return c;
  }

  if (c.constructor == "Object") {
    return c;
  } else {
    const s = x.constructor.toString();
    const i = s.indexOf("(");
    return s.substring(9, i); // function ?( ... 의 특성을 이용함
  }
}

/** 대시보드로 이동하는 url 제작
 * @param {string} path ex) /summary, /test, /status
 * @param {number} projectId
 * @param {number} taskId
 */
function getDashboardUrl(path, projectId, taskId) {
  let params = `?projectId=${projectId}`;
  if (taskId) params += `&taskId=${taskId}`;
  return path + params;
}

function renameKey(object, oldKey, newKey) {
  object = structuredClone(object);

  if (object[oldKey] === undefined) {
    return object;
  }

  object[newKey] = object[oldKey];
  delete object[oldKey];
  return object;
}

/** 작업공간 task_result 데이터 형식 변경에 따른, 전처리 메서드 */
function importTaskResult(objects, classes) {
  objects = structuredClone(objects);
  classes = structuredClone(classes);

  const ret = [];

  objects.forEach((obj) => {
    const cls = classes.find((cls) => cls.id === obj.classId);

    obj.color = cls.color;
    obj.options = cls.options;
    obj.childrens = [];

    if (obj.annotation === "GROUP_POINT") {
      const childrens = [];
      let pointIdx = 0;

      obj.group.forEach((g) => {
        g.points.forEach((pt, pidx) => {
          const template = {
            name: g.subGroupName,
            type: g.annotation,
            startIndex: pointIdx + 1,
            endIndex: pointIdx + g.points.length,
            points: [pt],
            attributes: [],
          };

          childrens.push(template);
          childrens[pointIdx].id = `${obj.id}-${pointIdx}`;

          cls.attributes.forEach((attr) => {
            const clonedAttr = structuredClone(attr);
            const gAttr = g.attributes.find(
              (ga) => ga.title === clonedAttr.name
            );

            clonedAttr.values.forEach((val) => {
              const selectedValues = gAttr?.values?.[pidx] || [];
              val.selected = selectedValues.includes(val.value);

              if (
                clonedAttr.type === "INPUT" &&
                !["", undefined, null].includes(selectedValues?.[0])
              ) {
                val.value = selectedValues[0];
                val.selected = true;
              }
            });

            childrens[pointIdx].attributes.push(clonedAttr);
          });
          pointIdx++;
        });
      });

      obj.childrens = childrens.map((child) => {
        const ordered = [];
        const clsAttributes = structuredClone(cls.attributes);
        clsAttributes.forEach((clsAttr) => {
          const matched = child.attributes.find((a) => a.name === clsAttr.name);
          ordered.push(matched || structuredClone(clsAttr));
        });
        child.attributes = ordered;
        return child;
      });
    } else {
      obj.attributes = obj.attributes.map((attr) =>
        importAttribute(
          attr,
          cls.attributes.find((clsAttr) => clsAttr.name === attr.title)
        )
      );

      const attrs = [];
      const clsAttributes = structuredClone(cls.attributes);
      clsAttributes.forEach((clsAttr) => {
        const targetAttr =
          obj.attributes.find((attr) => attr.name === clsAttr.name) || clsAttr;

        attrs.push(targetAttr);
      });

      obj.attributes = attrs;

      if (obj.lineAttributes && obj.lineAttributes.length > 0) {
        obj.lineAttributes.forEach((line) => {
          // [TODO] line의 start, end idx가 객체 포인트 범위를 벗어나는 이슈가 있어, 임시로 추가한 코드
          const len = obj.points.length;
          line.startPointNum =
            line.startPointNum >= len - 1 ? len - 1 : line.startPointNum;
          line.endPointNum =
            line.endPointNum >= len - 1 ? len - 1 : line.endPointNum;
          line.attributes = line.attributes.map((attr, idx) =>
            importAttribute(attr, cls.lineAttribute.attributes[idx])
          );
        });
        obj.lineOptions = cls.lineAttribute.option;
      }
    }

    obj = renameKey(obj, "annotation", "type");
    obj = renameKey(obj, "className", "name");
    delete obj.group;

    ret.push(obj);
  });

  return ret;
}

/** 작업공간 task_result 데이터 형식 변경에 따른, 후처리 메서드 */
function exportTaskResult(objects, classes) {
  objects = structuredClone(objects);
  const ret = [];

  objects.forEach((obj) => {
    if (obj.type === "GROUP_POINT") {
      const group = [];
      let name = "";
      let groupIdx = -1;

      const _class = classes.find((cls) => cls.id === obj.classId);
      obj.childrens.forEach((child) => {
        child.attributes = filterAttributeByParentInfo(
          child.attributes,
          _class
        );
      });

      obj.childrens.forEach((child) => {
        if (child.name !== name) {
          const attributes = child.attributes.map((attr) => {
            return {
              title: attr.name,
              type: attr.type,
              optionType: attr.option.type,
              values: [],
            };
          });

          group.push({
            subGroupName: child.name,
            annotation: "SUB_POINT",
            points: [],
            attributes,
          });

          name = child.name;
          groupIdx++;
        }

        group[groupIdx].points.push(child.points[0]);
        child.attributes.forEach((attr, idx) => {
          const values = attr.values
            .filter((v) => v.selected)
            .map((v) => v.value);

          if (attr.type === "INPUT") {
            if ([null, ""].includes(values[0])) {
              group[groupIdx].attributes[idx].values.push([]);
              return;
            }
          }

          group[groupIdx].attributes[idx].values.push(values);
        });
      });

      obj.group = group;

      delete obj.attributes;
      delete obj.childrens;
    } else {
      const _class = classes.find((cls) => cls.id === obj.classId);
      obj.attributes = filterAttributeByParentInfo(obj.attributes, _class);
      obj.attributes = obj.attributes.map((attr) => exportAttribute(attr));

      if (obj.lineAttributes) {
        obj.lineAttributes.forEach((line) => {
          // [TODO] line의 start, end idx가 객체 포인트 범위를 벗어나는 이슈가 있어, 임시로 추가한 코드
          const len = obj.points.length;
          line.startPointNum =
            line.startPointNum >= len - 1 ? len - 1 : line.startPointNum;
          line.endPointNum =
            line.endPointNum >= len - 1 ? len - 1 : line.endPointNum;
          line.attributes = line.attributes.map((attr) =>
            exportAttribute(attr)
          );
        });
        delete obj.lineOptions;
      }
    }

    obj = renameKey(obj, "name", "className");
    obj = renameKey(obj, "type", "annotation");

    ret.push(obj);
  });

  return ret;
}

function importAttribute(attribute, classAttribute) {
  attribute = structuredClone(attribute);
  classAttribute = structuredClone(classAttribute);

  if (attribute.values.length > 0 && attribute.values[0].value !== undefined) {
    // 이미 import 형식에 맞을 떄 (redo & undo 시)
    return attribute;
  } else {
    classAttribute.values.forEach((value) => {
      value.selected = attribute.values.includes(value.value);

      if (
        attribute.type === "INPUT" &&
        ![undefined, null, ""].includes(attribute.values[0])
      ) {
        value.value = attribute.values[0];
        value.selected = true;
      }
    });
  }

  attribute = renameKey(attribute, "title", "name");
  attribute.option = classAttribute.option;
  attribute.values = classAttribute.values;
  // propagate additional class attribute props
  attribute.colorPalette = classAttribute.colorPalette;
  attribute.parentInfo = classAttribute.parentInfo || null;
  delete attribute.optionType;

  return attribute;
}
function exportAttribute(attribute) {
  attribute = structuredClone(attribute);

  attribute.values = attribute.values
    .filter((val) => val.selected)
    .map((val) => val.value);

  if (attribute.type === "INPUT") {
    if (
      attribute.values[0]?.value === "" ||
      [null, "", undefined].includes(attribute.values[0])
    ) {
      attribute.values = [];
    }
  }

  attribute = renameKey(attribute, "name", "title");
  attribute.optionType = attribute.option.type;
  delete attribute.option;
  delete attribute.colorPalette;
  return attribute;
}

function filterAttributeByParentInfo(attributes, _class) {
  return attributes.filter((attr) => {
    const clsAttribute = _class.attributes.find(
      (clsAttr) => clsAttr.name === attr.name
    );

    if (!clsAttribute.parentInfo) {
      return true;
    }

    const { parentIndex, valueIndex } = clsAttribute.parentInfo;
    const parent = attributes[parentIndex];
    const value = parent.values[valueIndex];
    return value.selected;
  });
}

function getKoreanDayOfWeek(date) {
  const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
  return daysOfWeek[date.getDay()];
}
function formatTime(time) {
  return time < 10 ? "0" + time : time;
}
function formatDate(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const formattedStartDate = `${start.getFullYear()}-${
    start.getMonth() + 1
  }-${start.getDate()}(${getKoreanDayOfWeek(start)}) ${formatTime(
    start.getHours()
  )}:${formatTime(start.getMinutes())}:${formatTime(start.getSeconds())}`;
  const formattedEndDate = `${end.getFullYear()}-${
    end.getMonth() + 1
  }-${end.getDate()}(${getKoreanDayOfWeek(end)}) ${formatTime(
    end.getHours()
  )}:${formatTime(end.getMinutes())}:${formatTime(end.getSeconds())}`;
  return `${formattedStartDate} ~ ${formattedEndDate}`;
}

function isArrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}

function extractArray(targetArray, startIdx, endIdx) {
  if (startIdx <= endIdx) {
    return targetArray.slice(startIdx, endIdx + 1);
  } else {
    return targetArray.slice(startIdx).concat(targetArray.slice(0, endIdx + 1));
  }
}

function distinctNestedArray(array) {
  return Array.from(new Set(array.map(JSON.stringify))).map(JSON.parse);
}

function getSideSegments(length, startIdx, endIdx) {
  let result = [];
  while (startIdx !== endIdx) {
    let nextIdx = (startIdx + 1) % length;
    result.push([startIdx, nextIdx]);
    startIdx = nextIdx;
  }
  return result;
}

function getSideIndexes(length, start, end) {
  const result = [];

  while (start !== end) {
    result.push(start);
    start = start + 1 > length - 1 ? 0 : start + 1;
  }
  result.push(end);

  return result;
}

// 특정 하위 속성이 Visible 상태인지 판별하는 함수
function isAttributeVisible(attributes, index) {
  const attr = attributes[index];
  if (!attr || !attr.parentInfo) return true;

  const { parentIndex, valueIndex } = attr.parentInfo || {};
  const parent = attributes[parentIndex];
  if (!parent) {
    console.error("부모를 찾지 못했습니다. (부모는 없을 수 없음)");
    return false;
  }

  switch (parent.type) {
    case "RADIO": {
      const selectedIdx = parent.values.findIndex((v) => v.selected);
      return selectedIdx === valueIndex;
    }
    case "CHECKBOX": {
      const opt = parent.values[valueIndex];
      return !!(opt && opt.selected);
    }
    default:
      return false;
  }
}

function resetAttribute(attribute, clsAttribute) {
  switch (attribute.type) {
    case "RADIO":
    case "CHECKBOX":
      attribute.values = structuredClone(clsAttribute.values);
      break;
    case "INPUT":
      attribute.values = [{ value: "", selected: false }];
      break;
  }
}

// 중첩된 속성 목록 중, 속성이 숨겨진 경우에 해당 속성의 값을 초기화 해버림
// 부모가 초기화 되면, 자식도 연쇄적으로 초기화
function enforceNestedVisibility(attributes, _class) {
  const maxIterations = (attributes || []).length + 1;
  for (let iter = 0; iter < maxIterations; iter++) {
    let changed = false;
    attributes.forEach((attr, idx) => {
      if (!isAttributeVisible(attributes, idx)) {
        const hadValue =
          (attr.type === "INPUT" && (attr.values?.[0]?.value || "") !== "") ||
          (attr.type !== "INPUT" && attr.values?.some((v) => v.selected));
        if (hadValue) {
          resetAttribute(attr, _class.attributes[idx]);
          changed = true;
        }
      }
    });
    if (!changed) break;
  }
}

/** 난수 생성 */
function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 15);
}

function escapeDOM(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

export default {
  setLocalStorage,
  getLocalStorage,
  removeCookie,
  parsePrice,
  getToken,
  setToken,
  removeToken,
  datetimeFormat,
  changeRoleToStr,
  changeRoleToCode,
  changeStatusToCode,
  checkLoginCode,
  getRandomKey,
  toDataURL,
  comma,
  setWorkCode,
  dateFormat,
  checkObjectHasError,
  checkBoxSizeHasError,
  checkPolygonHasError,
  checkAttributesHasError,
  executeCompleteCheck,
  executeDeleteCheck,
  executeRejectCheck,
  checkWordHasWarn,
  getComplementaryColor,
  validateGroupPoint,
  getDateFormat,
  getDateFormatToYYYYMMDDHHMMSS,
  copyClipboard,
  convertSize,
  sortClassTypes,
  getExactType,
  getDashboardUrl,
  renameKey,
  importTaskResult,
  exportTaskResult,
  formatBirthDate,
  formatDate,
  isArrayEqual,
  extractArray,
  distinctNestedArray,
  getSideSegments,
  getSideIndexes,
  generateId,
  escapeDOM,
  isAttributeVisible,
  enforceNestedVisibility,
  resetAttribute,
};
